import React, {useState} from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DomesticPackages from '../data/domesticPackage.json';
import InternationPackages from '../data/internationPackages.json';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Paper,
} from '@mui/material';
import ChatBox from '../components/ChatBox';
import EnquiryFormModal from '../components/EnquiryFormModal';



const DomAndIntPackageList = () => {
    const location= useLocation();
    const tripType = location.pathname.split('/')[1];
    console.log(tripType," trip type")
    console.log(location.pathname.split('/'),"location")
    const allPackages = tripType === 'internationaltrips' ?  [...InternationPackages] : [...DomesticPackages];
    const { destinationId } = useParams();
    console.log(destinationId,"destinationId")
    const navigate = useNavigate();
    const [openEnquiry, setOpenEnquiry] = useState(false);
    const destination = allPackages.filter(p => p.name === destinationId);
    console.log(allPackages, "find destination")
    if (!destination) {
        return (
            <Box p={4}>
                <Typography variant="h6">Destination not found</Typography>
            </Box>
        );
    }
    console.log(destination, '--->dest')
    return (
        <Box>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: { xs: 200, sm: 300, md: 400, lg:400 },
                    mb: 4,
                }}
            >
                <img
                    src={destination[0].featuredImage}
                    alt={destination.location}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(0, 0, 0, 0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        borderRadius: '8px',
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        Explore  <small style={{ color: "orange" }}>{destination?.location ||  destination && destination[0]?.destinationslug }</small> City
                    </Typography>
                </Box>
            </Box>
            <ChatBox />
            <Box p={4}>
                <Typography variant="h4" mb={3}>Packages for {destination?.location ||  destination && destination[0]?.destinationslug }</Typography>

                <Paper sx={{
                    overflowX: 'auto',
                    boxShadow: 4,
                    borderRadius: 2,
                }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Package</strong></TableCell>
                                { destination && destination.length > 0 && destination[0].duration && <TableCell><strong>Duration</strong></TableCell>}
                                { destination && destination.length > 0 && destination[0].price && <TableCell><strong>Price</strong></TableCell>}
                                <TableCell><strong>Description</strong></TableCell>
                                <TableCell><strong>Action</strong></TableCell>
                                <TableCell><strong> Details</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {destination && destination.map(pkg => (
                                <TableRow key={pkg.id}>
                                    <TableCell style={{ color: "#0e8279", fontWeight: "bold" }}>{pkg.name}</TableCell>
                                   {pkg.duration &&  <TableCell>{pkg.duration}</TableCell>}
                                   {pkg.price && <TableCell>{pkg.price}</TableCell>}
                                    {/* <Typography mt={2} dangerouslySetInnerHTML={{ __html: pkg.description }} /> */}
                                    <TableCell>{pkg.description?.replace(/<[^>]+>/g, '').slice(0, 120) + '...'}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            sx={{color :'white', backgroundColor :'#0e8279'}}
                                            onClick={() => navigate(`/${tripType}/${destinationId}/${pkg._id}`)}
                                        >
                                            View Details
                                        </Button>
                                    </TableCell>
                                    <TableCell><Button sx={{
                                        color: '#0e8279'
                                    }} onClick={() => setOpenEnquiry(true)}>Enquire Now</Button></TableCell>
                                    <EnquiryFormModal open={openEnquiry} setOpen={setOpenEnquiry} />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>




                {/* <Grid container spacing={3}>
                    {destination?.packages.map(pkg => (
                        <Grid item xs={12} md={4} key={pkg.id}>
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h6">{pkg.name}</Typography>
                                    <Typography variant="body2">{pkg.duration}</Typography>
                                    <Typography variant="body2" color="text.secondary">{pkg.description}</Typography>
                                    <Typography variant="body2" color="green" mt={1}>{pkg.price}</Typography>
                                    <Button
                                        variant="outlined"
                                        onClick={() => navigate(`/packages/${destinationId}/${pkg.id}`)}
                                        sx={{ mt: 2 }}
                                    >
                                        View Details
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid> */}
                {destination.overview && (
                    <Box
                        mt={6}
                        p={3}
                        sx={{
                            backgroundColor: '#fff',
                            border: '1px solid #e0e0e0',
                            borderRadius: 2,
                            boxShadow: 1,
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold" mb={3} gutterBottom borderBottom={1}>
                            Overview
                        </Typography>

                        {destination.overview.map((item, i) => (
                            <Typography
                                key={i}
                                variant="body1"
                                paragraph
                                sx={{ mb: 2, lineHeight: 1.7 }}
                            >
                                {item.title && (
                                    <strong style={{ fontWeight: 'bold' }}>{item.title}</strong>
                                )}{' '}
                                {item.text}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Box>

        </Box>
    );
};

export default DomAndIntPackageList;
